var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#047857"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6885_1298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 36,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6885_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 39C12.675 39 11.9688 38.7063 11.3813 38.1188C10.7938 37.5312 10.5 36.825 10.5 36V15C10.5 14.175 10.7938 13.4688 11.3813 12.8813C11.9688 12.2938 12.675 12 13.5 12H15V9H18V12H30V9H33V12H34.5C35.325 12 36.0312 12.2938 36.6188 12.8813C37.2063 13.4688 37.5 14.175 37.5 15V22.5H34.5V21H13.5V36H24V39H13.5ZM13.5 18H34.5V15H13.5V18ZM27 39V34.3875L35.2875 26.1375C35.5125 25.9125 35.7625 25.75 36.0375 25.65C36.3125 25.55 36.5875 25.5 36.8625 25.5C37.1625 25.5 37.45 25.5562 37.725 25.6688C38 25.7812 38.25 25.95 38.475 26.175L39.8625 27.5625C40.0625 27.7875 40.2188 28.0375 40.3313 28.3125C40.4438 28.5875 40.5 28.8625 40.5 29.1375C40.5 29.4125 40.45 29.6938 40.35 29.9813C40.25 30.2688 40.0875 30.525 39.8625 30.75L31.6125 39H27ZM29.25 36.75H30.675L35.2125 32.175L34.5375 31.4625L33.825 30.7875L29.25 35.325V36.75ZM34.5375 31.4625L33.825 30.7875L35.2125 32.175L34.5375 31.4625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerIcon);
export default __webpack_public_path__ + "static/media/Scheduler_icon.1073de35107b3c401b425ea64cd0b2ef.svg";
export { ForwardRef as ReactComponent };